import { API_BASE_REPORT_API_URL } from '../../urls';

export const API_CUSTOM_FILES_URL = `${API_BASE_REPORT_API_URL}/custom-files/files`;

export const API_CUSTOM_FILES_GET = `${API_CUSTOM_FILES_URL}/get`;
